
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/hrms-portals",
      function () {
        return require("private-next-pages/products/hrms-portals.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/hrms-portals"])
      });
    }
  